export const chapters = {
    welcome: 'welcome',
    whatsNew: 'whatsNew',
    feedback: 'feedback',
} as const;

type RecursiveValueOf<T> = T extends string
    ? T
    : T extends Record<string, unknown>
      ? RecursiveValueOf<T[keyof T]>
      : never;

export type ServiceInfoChapter = RecursiveValueOf<typeof chapters>;
